import * as React from 'react';
import { Check, X, Loader2 } from 'lucide-react';
import { setOpenToast } from '../../../../store/helpers/helperReducers';
import { useStoreDispatch } from '../../../../store/hooks';
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '../../../ui/tooltip';

interface ConfigureTestProps {
  testResult: any;
  errorMessage: string | null;
}

const ConfigureTest: React.FC<ConfigureTestProps> = ({ testResult, errorMessage }) => {

  const dispatch = useStoreDispatch();

  React.useEffect(() => {
    if (errorMessage) {
      dispatch(setOpenToast({ openToast: true, message: errorMessage, toastType: "error" }));
    } else if (testResult) {
      Object.values(testResult).forEach(value => {
        if (typeof value === 'string' && value.startsWith("Error")) {
          dispatch(setOpenToast({ openToast: true, message: value, toastType: "error" }));
        }
      });
    }
  }, [dispatch, errorMessage, testResult]);

  return (
    <div className="flex flex-col gap-6">
      <h5 className="text-lg font-semibold text-foreground mb-2">
        Server Status
      </h5>
      <div className="flex flex-col gap-3">
        {testResult ? (
          Object.keys(testResult).map((key, index) => {
            const isPassed = testResult[key] === "PASS";
            return (
              <div className="flex items-center gap-3" key={`status-${index}`}>
                <div className={`flex items-center justify-center w-7 h-7 rounded-full shrink-0 ${
                  isPassed ? 'bg-green-500' : 'bg-destructive'
                }`}>
                  {isPassed ? (
                    <Check className="h-4 w-4 text-white" />
                  ) : (
                    <X className="h-4 w-4 text-white" />
                  )}
                </div>
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <span className="text-sm text-foreground cursor-default">{key}</span>
                    </TooltipTrigger>
                    <TooltipContent side="right">{testResult[key] || ''}</TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              </div>
            );
          })
        ) : (
          <Loader2 className="h-10 w-10 animate-spin text-green-500" />
        )}
      </div>
    </div>
  );
}

export default ConfigureTest;